<template>
  <div>
    <b-card>
      <div slot="header">
        {{ $lang.azmoonLang.choose_azmoon_execute_exam_pack }}
      </div>
      <div class="alert alert-warning" role="alert">
        <div class="detail_body">
          <div class="open-tab">
            <h6
              v-text="$lang.azmoonLang.choose_azmoon_execute_person_tooltip"
            />
            <p
              v-text="$lang.azmoonLang.choose_azmoon_execute_person_description"
            />
          </div>
        </div>
      </div>
      <b-row>
        <b-col cols="12">
          <b-row
            v-for="(v, index) in $v.items.$each.$iter"
            :key="index"
            class="my-2"
          >
            <b-col class="px-main-1" cols="12" :md="allowShowName ? 4 : 6">
              <requiredComponent
                class="my-2 d-none d-md-block"
                v-if="index == 0"
                slot="label"
                :label="$lang.azmoonLang.exam_pack"
                :rules="v.exam_pack.$params"
              />
              <label class="d-block d-md-none" for="">{{
                $lang.azmoonLang.exam_pack
              }}</label>

              <selectAsync
                :options="exam_pack_options"
                v-model="v.exam_pack.$model"
                label="caption"
                :isValid="v.exam_pack.$dirty ? !v.exam_pack.$error : null"
                :loading="examPackLoading"
                :asyncFind="getExamPack"
              />
            </b-col>
            <b-col v-if="allowShowName" cols="12" :md="allowShowName ? 4 : 5">
              <b-form-group
                :label="$lang.sample_name"
                label-for="exam_pack_show_name"
                :label-cols="$config.azmoon.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.sample_name"
                  :rules="v.exam_pack_show_name.$params"
                />
                <b-form-input
                  id="sample_name"
                  type="text"
                  :autocomplete="$lang.sample_name"
                  v-model="v.exam_pack_show_name.$model"
                  :state="
                    v.exam_pack_show_name.$dirty
                      ? !v.exam_pack_show_name.$error
                      : null
                  "
                >
                </b-form-input>
                <b-form-invalid-feedback id="sample_name-feedback"
                  >{{
                    $lang.azmoonLang.error_required | replace($lang.sample_name)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col class="px-main-1" cols="12" :md="allowShowName ? 3 : 5">
              <label v-if="index == 0" class="mt-2 d-none d-md-block" for="">{{
                $lang.azmoonLang.azmoon_term_state
              }}</label>
              <label class="d-block d-md-none" for="">{{
                $lang.azmoonLang.azmoon_term_state
              }}</label>
              <selectFind
                :options="azmoon_term_state_options"
                v-model="v.azmoon_term_state_selected.$model"
                label="caption"
                :isValid="
                  v.azmoon_term_state_selected.$dirty
                    ? !v.azmoon_term_state_selected.$error
                    : null
                "
                :loading="azmoon_term_state_loading"
              />
            </b-col>
            <b-col class="px-main-1" cols="12" md="1">
              <label v-if="index == 0" for="">&nbsp;&nbsp;</label
              ><br v-if="index == 0" />

              <b-button
                v-if="index == 0"
                variant="success"
                @click="add"
                class="mt-main-2 mr-1"
              >
                <i class="fa fa-plus"></i>
              </b-button>
              <b-button
                v-if="index > 0"
                variant="danger"
                :class="index == 0 ? `mt-main-2` : `mt-1`"
                @click="deleteItem(index)"
              >
                <i class="fa fa-minus-circle"></i>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "azmoon-execute-exam-pack-form",
  validations: {
    items: {
      $each: {
        exam_pack: {
          required,
        },
        exam_pack_show_name: {
          required: requiredIf((vm) => vm.allowShowName),
        },
        azmoon_term_state_selected: {},
      },
    },
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    azmoon_execute_id: {
      type: [Number, String],
      default: "",
    },
    term_code: {
      type: [Number, String],
      default: "",
    },
    allowShowName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      items: [
        {
          exam_pack: null,
          exam_pack_show_name: null,
          state: null,
          azmoon_term_state_selected: null,
        },
      ],
      azmoon_execute_person_url: "",
      person_url: this.$config.api_url + this.$config.azmoon.person,
      person_options: [],
      person_selected: null,
      personLoading: false,
      operator_options: [],
      operator_selected: null,
      operatorLoading: false,
      reference_options: [],
      reference_selected: null,
      referenceLoading: false,
      openText: true,
      examPackLoading: false,
      exam_pack_options: [],
      stateDefineloading: false,
      azmoon_term_state_options: [],
      azmoon_term_state_loading: true,
      azmoon_term_state_selected: null,
      sample_name: null,
    };
  },
  watch: {
    value() {
      this.items = this.value;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    generateApiUrl,
    toggle() {
      this.openText = !this.openText;
    },
    handleBack() {
      this.$emit("cancel");
    },
    deleteItem(index) {
      if (index == 0) {
        return;
      }
      this.items.splice(index, 1);
    },
    add() {
      this.items.push({
        exam_pack: null,
        exam_pack_show_name: null,
        state_group: null,
        state: null,
        azmoon_term_state_selected: null,
      });
    },
    async getExamPack(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.exam_pack_options = [];
      }
      try {
        this.examPackLoading = true;
        const url = generateApiUrl(["azmoon", "available_exam_pack"]);
        let params = {
          search_txt: query,
          show_as_final: 1,
        };
        const response = await this.$httpService.get(url, params);
        let exam_packs = response.data.data;
        exam_packs = exam_packs.map((exam_pack) => {
          const id = pathOr("", ["id"], exam_pack);
          const name = pathOr("", ["exam_pack_name"], exam_pack);
          exam_pack.caption = `${id}- ${name}`;
          return exam_pack;
        });
        this.exam_pack_options = exam_packs;
      } catch (error) {
        this.$generateError(error);
        this.exam_pack_options = [];
      } finally {
        this.examPackLoading = false;
      }
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      if (this.selected == 2) {
        this.is_image = 0;
      }
      let payload = {
        is_enable: this.is_enable,
        option_description: this.option_description,
        is_image: this.is_image,
      };
      this.$emit("submit", payload);
    },
    async getAzmoonTermStateId() {
      this.azmoon_term_state_options = [];
      try {
        this.azmoon_term_state_loading = true;
        const url = generateApiUrl(
          ["azmoon", "azmoon_term_state_id"],
          [this.term_code]
        );
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.azmoon_term_state_options = data.map((x) => {
          return {
            caption: x.state_caption,
            value: x.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoon_term_state_loading = false;
      }
    },
    async fetchData() {
      this.getAzmoonTermStateId();
    },
  },
};
</script>

<style>
.px-main-1 {
  padding: 0 3px;
  margin-top: 3px;
}

.mt-main-2 {
  margin-top: 8px;
}
</style>
